import { jsx } from 'react/jsx-runtime';
import 'react';

const WishketNaverBlog = ({ testId, className })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: /*#__PURE__*/ jsx("path", {
            d: "M3 2H5.58706L10.529 10.0504H10.5622V2H13V14H10.3964L5.47098 5.96639H5.43781V14H3V2Z",
            fill: "#9E9E9E"
        })
    });
};

export { WishketNaverBlog as default };
